

































































































import { Mixins, Component, Watch } from 'vue-property-decorator'
import { debounce } from 'quasar'
import * as Y from 'yjs'
import Delta from 'quill-delta'
import stringDiffDelta from 'src/assets/stringDiffDelta'
import MixinForm from 'components/presenter/item/topic/editor/MixinForm'
import stringCompare from 'src/assets/stringCompare'
import FormSlide from 'components/presenter/item/topic/editor/FormSlide.vue'
import IntegerInput from 'components/IntegerInput.vue'
import AnswersEditor from 'components/presenter/item/topic/editor/AnswersEditor.vue'

interface definition {
  gaps: string
  correct: string[]
}

@Component({
  components: {
    FormSlide,
    IntegerInput,
    AnswersEditor
  }
})
export default class ItemTopicSlidesEditorFormGaps extends Mixins(MixinForm) {
  value = ''
  typing = false

  get gaps (): Y.Doc {
    return this.slide.gaps
  }

  created () {
    this.update = debounce(this.update, 1000)
    const slidesTexts: Json = {}
    slidesTexts[`${this.slide.id}:gaps`] = []
    this.item.data?.update({ slidesTexts })
  }

  beforeDestroy () {
    this.gaps?.getText().unobserve(this.observer)
  }

  @Watch('gaps', { immediate: true })
  watchGaps (gaps: Y.Doc | undefined, prev: Y.Doc | undefined) {
    prev?.getText().unobserve(this.observer)
    if (gaps) {
      gaps.getText().observe(this.observer)
      this.inputUpdate(gaps.getText().toString(), this.correct)
    }
  }

  observer (event: Y.YTextEvent, transaction: Y.Transaction) {
    if (!this.typing) {
      this.inputUpdate(this.gaps.getText().toString(), this.correct)
    }
  }

  @Watch('correct', { immediate: true })
  watchCorrect (correct: string[]) {
    this.inputUpdate(this.gaps?.getText().toString() || '', correct)
  }

  inputUpdate (gaps: string, correct: string[]) {
    const answers = [...correct]
    let value = ''
    const parts = gaps.split(/(\[\[\]\])/)
    for (const part of parts) {
      if (part === '[[]]') {
        value += `[[${answers.shift()||''}]]`
      } else {
        value += part
      }
    }
    if (this.value.trim() !== value.trim()) {
      this.value = value
    }
  }

  input (value: string) {
    this.typing = true
    this.update(value)
  }

  update (value: string) {
    this.typing = true
    if (this.value.trim() !== value.trim()) {
      const previous = this.extract(this.value)
      const current = this.extract(value)
      const delta = stringDiffDelta(previous.gaps, current.gaps)
      if (delta.ops.length) {
        this.gaps.transact(() => {
          this.gaps.getText().applyDelta(delta.ops)
        }, 'SLIDE_GAPS_EDIT')
      }
      this.setCorrect(current.correct)
      if (this.slide.dropdown) {
        if (this.slide.selects) {
          this.setOption('dropdown', this.getSelectsOptions(current.correct))
        } else {
          this.setOption('dropdown', this.getDropdownOptions(current.correct))
        }
      }
      this.value = value
    }
    this.typing = false
  }

  extract (value: string): definition {
    const def: definition = {
      gaps: '',
      correct: []
    }
    const parts = value.split(/(\[\[[^\]]*\]\])/)
    for (const part of parts) {
      const gap = part.match(/^\[\[(.*)\]\]$/)
      if (gap) {
        def.gaps += '[[]]'
        def.correct.push(gap[1])
      } else {
        def.gaps += `${part}`
      }
    }
    return def
  }

  toggleDropdown () {
    if (this.slide.dropdown) {
      this.setOption('dropdown', null)
    } else {
      if (this.slide.selects) {
        this.setOption('dropdown', this.getSelectsOptions(this.correct))
      } else {
        this.setOption('dropdown', this.getDropdownOptions(this.correct))
      }
    }
  }

  toggleSelects () {
    if (this.slide.selects) {
      this.setOption('selects', null)
      if (this.slide.dropdown) {
        this.setOption('dropdown', this.getDropdownOptions(this.correct))
      }
    } else {
      this.setOption('selects', true)
      this.setOption('dropdown', this.getSelectsOptions(this.correct))
    }
  }

  getDropdownOptions (correct: string[]) {
    const options = new Set<string>()
    for (const value of correct) {
      value.split('/').forEach((option: string) => { if (option.trim()) { options.add(option.trim()) } })
    }
    return [...options].sort(stringCompare)
  }

  getSelectsOptions (correct: string[]) {
    const selects = []
    for (const value of correct) {
      const options = new Set<string>()
      value.split('/').forEach((option: string) => { if (option.trim()) { options.add(option.trim()) } })
      selects.push( [...options].sort(stringCompare) )
    }
    return selects
  }
}
